import React from "react";
import "./App.scss";
import VersionRouter from "./routes/VersionRouter";

function App() {
  return (
    <div>
      <VersionRouter />
    </div>
  );
}

export default App;
